import { createSlice } from '@reduxjs/toolkit';
import type { NormalizedError } from 'errors/types';

export type SolarRegistrationState = {
  isLoading: boolean;
  errors: null | NormalizedError[];
  details: {
    firstName: string | null;
    lastName: string | null;
    electricityAccountNumber: string | null;
    email: string | null;
    phoneNumber: string | null;
    address: string | null;
  };
  data: Record<string, unknown>;
};

export const initialState: SolarRegistrationState = {
  isLoading: false,
  errors: null,
  details: {
    firstName: null,
    lastName: null,
    electricityAccountNumber: null,
    email: null,
    phoneNumber: null,
    address: null
  },
  data: {}
};

export const slice = createSlice({
  name: 'solarRegistration',
  initialState,
  reducers: {
    setInitialState: (state) => {
      Object.entries(initialState).forEach(
        ([key, value]) => (state[key] = value)
      );
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },

    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = {};
      state.errors = payload;
    },
    setFormField: (state, { payload: { name, value } }) => {
      state.details[name] = value;
    }
  }
});

export const {
  setInitialState,
  setFormField,
  setSuccess,
  setError,
  setIsLoading
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectDetails = (state) => selectSlice(state).details;
export const selectIsLoading = (state) => selectSlice(state).isLoading;
export const selectErrors = (state) => selectSlice(state).errors;
export const selectData = (state) => selectSlice(state).data;

export default slice.reducer;
